import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface Tag {
  id: number;
  name: string;
  category: string;
  description: string | null;
  color: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: () => apiClient<Tag[]>('/tags'),
  });
}

function useInvalidateTags() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ['tags'] });
    queryClient.invalidateQueries({ queryKey: ['tracks'] });
    queryClient.invalidateQueries({ queryKey: ['subscription-packages'] });
  };
}

export interface TagDraft {
  name?: string;
  description?: string | null;
  category?: string;
}

export function useCreateTag() {
  const invalidate = useInvalidateTags();
  return useMutation({
    mutationFn: (draft: TagDraft) => apiClient<Tag>('/tags', { method: 'POST', body: JSON.stringify(draft) }),
    onSuccess: invalidate,
  });
}

export function useUpdateTag() {
  const invalidate = useInvalidateTags();
  return useMutation({
    mutationFn: ({ id, ...fields }: TagDraft & { id: number }) =>
      apiClient<Tag>(`/tags/${id}`, { method: 'PUT', body: JSON.stringify(fields) }),
    onSuccess: invalidate,
  });
}

export function useDeleteTag() {
  const invalidate = useInvalidateTags();
  return useMutation({
    mutationFn: (id: number) => apiClient<{ message: string }>(`/tags/${id}`, { method: 'DELETE' }),
    onSuccess: invalidate,
  });
}
